import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { FiLayers, FiPlus, FiX, FiTrash2, FiUsers, FiCalendar, FiMapPin, FiRepeat, FiPackage } from 'react-icons/fi';
import {
  listarBlocosRotina, criarBlocoRotina, atualizarBlocoRotina, excluirBlocoRotina,
  RECORRENCIAS, DIAS_SEMANA, MESES, textoRecorrencia, textoDiaRotina,
  listarPacotesRotina, criarPacoteRotina, atualizarPacoteRotina, excluirPacoteRotina,
  SETORES_ROTINA, rotuloSetor,
} from '../../services/rotinasProgramadas';
import { listarClientes } from '../../services/clientes';
import css from './CadastroRotinas.module.css';
import useEsc from '../../hooks/useEsc';

/* Menu Rotinas -- cadastro do que aparece na aba Vencimentos do Painel.
     RECORRÊNCIA semanal, mensal, trimestral, semestral, anual ou não repete
     DATA        quando repete, só os DIAS (início e fim) -- mês e ano vêm
                 da recorrência; trimestral/semestral/anual dizem o mês
     LOCAL       opcional (RFB, PGFN, Prefeitura...)
     ROTINA      nome + dia, sempre dentro do período
   Mais os clientes que fazem (são as linhas em Vencimentos). */

function competenciaAtual() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
function normalizar(t) {
  return (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}
const novaRotina = (setores = []) => ({ chave: Math.random().toString(36).slice(2), id: null, nome: '', dia: '', data: '', setores, incidencia: 'mensal', mes_vencimento: '' });
const MESES_NOME = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

/* escolher os setores que acompanham uma etapa (ou todas as do bloco).
   estadoDe(v) -> 'todos' | 'algum' | 'nenhum' (algum = só parte das etapas) */
function ModalSetores({ titulo, estadoDe, onAlternar, onFechar }) {
  useEsc(onFechar);
  return (
    <div className={css.fundo} style={{ zIndex: 95, justifyContent: 'center', alignItems: 'center' }}>
      <div className={css.modalClientes} style={{ maxWidth: 420, height: 'auto' }}>
        <div className={css.drawerTopo}>
          <div><h3>Setores</h3><p className={css.dica}>{titulo}</p></div>
          <button type="button" className={css.btnIcone} onClick={onFechar}><FiX size={16} /></button>
        </div>
        <div className={css.drawerCorpo}>
          <p className={css.dica}>Quem acompanha esta coluna em Vencimentos. Pode marcar mais de um (etapa feita em conjunto). Sem nenhum, aparece pra todos.</p>
          <div className={css.listaMarcar}>
            {SETORES_ROTINA.map(st => {
              const e = estadoDe(st.v);
              return (
                <label key={st.v} className={css.itemMarcar}>
                  <input type="checkbox" checked={e === 'todos'} ref={el => { if (el) el.indeterminate = e === 'algum'; }}
                    onChange={() => onAlternar(st.v, e !== 'todos')} />
                  <strong>{st.l}</strong>
                </label>
              );
            })}
          </div>
        </div>
        <div className={css.drawerRodape}>
          <span style={{ flex: 1 }} />
          <button type="button" className={css.btnPrimario} onClick={onFechar}>Pronto</button>
        </div>
      </div>
    </div>
  );
}
const DIAS_MES = Array.from({ length: 31 }, (_, i) => i + 1);

/* ════════════ Formulário do bloco ════════════ */
export function DrawerBloco({ registro, locais, onFechar, onSalvo }) {
  useEsc(onFechar);
  const editando = !!registro?.id;
  const [f, setF] = useState(() => ({
    recorrencia: registro?.recorrencia || 'mensal',
    inicio: registro?.inicio || '', fim: registro?.fim || '',
    dia_inicio: registro?.dia_inicio ?? '', dia_fim: registro?.dia_fim ?? '',
    semana_inicio: registro?.semana_inicio ?? 1, semana_fim: registro?.semana_fim ?? 5,
    mes_referencia: registro?.mes_referencia ?? '', vigencia_inicio: registro?.vigencia_inicio || competenciaAtual(),
    local: registro?.local || '', titulo: registro?.titulo || '',
    competencia_relativa: registro?.competencia_relativa ?? '', competencia_fixa: registro?.competencia_fixa || '',
  }));
  const [itens, setItens] = useState(() => (registro?.itens?.length
    ? registro.itens.map(i => ({ chave: i.id, id: i.id, nome: i.nome, dia: i.dia ?? '', data: i.data || '', setores: i.setores || [], incidencia: i.incidencia || 'mensal', mes_vencimento: i.mes_vencimento ?? '' }))
    : [novaRotina()]));
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [setoresDe, setSetoresDe] = useState(null); // { titulo, chaves } -- modal de setores
  const set = (c, v) => setF(x => ({ ...x, [c]: v }));
  /* setores: no título vale pra todas as etapas; na etapa, só nela */
  function estadoSetor(chaves, v) {
    const alvo = itens.filter(i => chaves.includes(i.chave));
    const n = alvo.filter(i => (i.setores || []).includes(v)).length;
    return n === 0 ? 'nenhum' : n === alvo.length ? 'todos' : 'algum';
  }
  function marcarSetor(chaves, v, sim) {
    setItens(xs => xs.map(x => {
      if (!chaves.includes(x.chave)) return x;
      const atual = new Set(x.setores || []);
      if (sim) atual.add(v); else atual.delete(v);
      return { ...x, setores: [...atual] };
    }));
  }
  const textoSetores = (lista) => (lista && lista.length ? lista.map(rotuloSetor).join(', ') : 'todos');
  const setItem = (chave, campo, valor) => setItens(xs => xs.map(x => (x.chave === chave ? { ...x, [campo]: valor } : x)));

  const rec = f.recorrencia;
  const unica = rec === 'unica', semanal = rec === 'semanal', precisaMes = ['trimestral', 'semestral', 'anual'].includes(rec);
  /* limites do período, no formato de cada recorrência */
  const min = unica ? f.inicio : Number(semanal ? f.semana_inicio : f.dia_inicio) || null;
  const max = unica ? f.fim : Number(semanal ? f.semana_fim : f.dia_fim) || null;
  const periodoOk = unica ? (f.inicio && f.fim) : (min && max);
  const foraDoPeriodo = (it) => {
    const v = unica ? it.data : Number(it.dia);
    return !!v && periodoOk && (v < min || v > max);
  };


  async function salvar() {
    setErro('');
    if (!periodoOk) return setErro(semanal ? 'Informe o dia da semana de início e de fim.' : unica ? 'Informe a data de início e a de fim.' : 'Informe o dia de início e o de fim.');
    if (max < min) return setErro('O fim não pode ser antes do início.');
    if (precisaMes && !f.mes_referencia) return setErro('Informe o mês em que vence.');
    /* o dia de cada rotina é opcional -- sem ele, o prazo é o fim do período */
    const lista = itens;
    if (lista.some(i => !i.nome.trim())) return setErro('Toda rotina precisa de nome.');
    if (lista.some(foraDoPeriodo)) return setErro('O dia de cada rotina tem que estar dentro do período.');
    if (rec === 'mensal' && lista.some(i => i.incidencia === 'anual' && !i.mes_vencimento)) return setErro('Informe o mês de vencimento de cada rotina anual.');
    setSalvando(true);
    try {
      const dados = {
        ...f, local: f.local,
        itens: lista.map(({ id, nome, dia, data, setores, incidencia, mes_vencimento }) => ({
          id, nome, dia: unica || !dia ? null : Number(dia), data: unica ? (data || null) : null, setores,
          incidencia: rec === 'mensal' ? (incidencia || 'mensal') : 'mensal',
          mes_vencimento: rec === 'mensal' && incidencia === 'anual' ? Number(mes_vencimento) : null,
        })),
      };
      if (editando) await atualizarBlocoRotina(registro.id, dados); else await criarBlocoRotina(dados);
      onSalvo();
    } catch (e) { setErro(e.message); setSalvando(false); }
  }

  async function excluir() {
    if (!window.confirm('Excluir esta rotina? As conclusões marcadas em Vencimentos também saem.')) return;
    try { await excluirBlocoRotina(registro.id); onSalvo(); } catch (e) { setErro(e.message); }
  }

  /* opções de dia da rotina, já presas dentro do período */
  const opcoesDia = semanal
    ? DIAS_SEMANA.map((d, i) => ({ v: i + 1, l: d })).filter(o => !periodoOk || (o.v >= min && o.v <= max))
    : DIAS_MES.filter(d => !periodoOk || (d >= min && d <= max)).map(d => ({ v: d, l: String(d).padStart(2, '0') }));

  return (
    <div className={css.fundo}>
      <div className={css.drawer} onClick={e => e.stopPropagation()}>
        <div className={css.drawerTopo}>
          <h3>{editando ? 'Editar rotina' : 'Nova rotina'}</h3>
          <button type="button" className={css.btnIcone} onClick={onFechar}><FiX size={16} /></button>
        </div>
        <div className={css.drawerCorpo}>
          <div className={css.parte}>
            <h4><FiRepeat size={12} /> Recorrência</h4>
            <div className={css.linha2}>
              <select className={css.input} value={rec} onChange={e => set('recorrencia', e.target.value)}>
                {RECORRENCIAS.map(r => <option key={r.v} value={r.v}>{r.l}</option>)}
              </select>
              {!unica && (
                <label className={css.campoInline}>Começa em
                  <input className={css.input} type="month" value={f.vigencia_inicio} onChange={e => set('vigencia_inicio', e.target.value)} />
                </label>
              )}
            </div>
            {precisaMes && (
              <label className={css.campo}><span>{rec === 'anual' ? 'Mês em que vence *' : '1º mês em que vence *'}</span>
                <select className={css.input} value={f.mes_referencia} onChange={e => set('mes_referencia', e.target.value ? Number(e.target.value) : '')}>
                  <option value="">Selecione...</option>
                  {MESES.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
                </select>
              </label>
            )}
            {precisaMes && f.mes_referencia && rec !== 'anual' && (
              <p className={css.dica}>Repete em {Array.from({ length: rec === 'trimestral' ? 4 : 2 }, (_, i) => MESES[(f.mes_referencia - 1 + i * (rec === 'trimestral' ? 3 : 6)) % 12].toLowerCase()).join(', ')}.</p>
            )}
          </div>

          <div className={css.parte}>
            <h4><FiCalendar size={12} /> Data</h4>
            {unica ? (
              <div className={css.linha2}>
                <label className={css.campo}><span>Início *</span>
                  <input type="date" value={f.inicio} onChange={e => { set('inicio', e.target.value); if (!f.fim || f.fim < e.target.value) set('fim', e.target.value); }} />
                </label>
                <label className={css.campo}><span>Fim *</span>
                  <input type="date" value={f.fim} min={f.inicio || undefined} onChange={e => set('fim', e.target.value)} />
                </label>
              </div>
            ) : semanal ? (
              <div className={css.linha2}>
                <label className={css.campo}><span>De *</span>
                  <select value={f.semana_inicio} onChange={e => set('semana_inicio', Number(e.target.value))}>
                    {DIAS_SEMANA.map((d, i) => <option key={d} value={i + 1}>{d}</option>)}
                  </select>
                </label>
                <label className={css.campo}><span>Até *</span>
                  <select value={f.semana_fim} onChange={e => set('semana_fim', Number(e.target.value))}>
                    {DIAS_SEMANA.map((d, i) => <option key={d} value={i + 1} disabled={i + 1 < f.semana_inicio}>{d}</option>)}
                  </select>
                </label>
              </div>
            ) : (
              <div className={css.linha2}>
                <label className={css.campo}><span>Dia de início *</span>
                  <select value={f.dia_inicio} onChange={e => { const v = Number(e.target.value); set('dia_inicio', v); if (!f.dia_fim || f.dia_fim < v) set('dia_fim', v); }}>
                    <option value="">—</option>
                    {DIAS_MES.map(d => <option key={d} value={d}>{String(d).padStart(2, '0')}</option>)}
                  </select>
                </label>
                <label className={css.campo}><span>Dia de fim *</span>
                  <select value={f.dia_fim} onChange={e => set('dia_fim', Number(e.target.value))}>
                    <option value="">—</option>
                    {DIAS_MES.map(d => <option key={d} value={d} disabled={!!f.dia_inicio && d < f.dia_inicio}>{String(d).padStart(2, '0')}</option>)}
                  </select>
                </label>
              </div>
            )}
            <p className={css.dica}>
              {unica ? 'Pode ser o mesmo dia.' : semanal ? 'Repete toda semana.' : 'Só os dias -- o mês e o ano vêm da recorrência. Dia 31 vira o último dia do mês.'}
              {' '}O dia próprio de cada rotina é opcional e fica preso dentro deste período; sem ele, o prazo é o fim.
            </p>
          </div>

          <div className={css.parte}>
            <h4><FiMapPin size={12} /> Local, título e competência <small>(opcionais)</small></h4>
            {/* em Vencimentos os três aparecem juntos, uma vez só sobre as rotinas
                deste bloco -- a competência em destaque (ex.: 10/26) */}
            <div className={css.linha3}>
              <input className={css.input} list="locais-rotina" value={f.local} onChange={e => set('local', e.target.value)} placeholder="Local: Dominio, RFB, PGFN..." />
              <input className={css.input} value={f.titulo} onChange={e => set('titulo', e.target.value)} placeholder="Título: Adiantamento, Folha..." />
              {unica ? (
                <input className={css.input} type="month" value={f.competencia_fixa} title="Competência das informações"
                  onChange={e => set('competencia_fixa', e.target.value)} />
              ) : (
                <select className={css.input} value={f.competencia_relativa} title="Competência das informações, em relação ao mês da rotina"
                  onChange={e => set('competencia_relativa', e.target.value === '' ? '' : Number(e.target.value))}>
                  <option value="">Competência: —</option>
                  <option value={-1}>Competência: mês anterior</option>
                  <option value={0}>Competência: mês corrente</option>
                  <option value={-2}>Competência: 2 meses antes</option>
                  <option value={-3}>Competência: 3 meses antes</option>
                </select>
              )}
            </div>
            <datalist id="locais-rotina">{locais.map(l => <option key={l} value={l} />)}</datalist>
          </div>

          <div className={css.parte}>
            <h4><FiLayers size={12} /> Rotinas
              <button type="button" className={css.btnLinha} style={{ marginLeft: 'auto' }}
                title="Marca o setor em todas as etapas deste bloco"
                onClick={() => setSetoresDe({ titulo: 'Todas as etapas deste bloco', chaves: itens.map(i => i.chave) })}>
                <FiUsers size={11} /> Setores de todas as etapas
              </button>
            </h4>
            {itens.map((it, n) => (
              <div key={it.chave} className={`${css.rotinaLinha} ${rec === 'mensal' ? css.rotinaLinhaInc : ''}`}>
                <input className={css.input} placeholder={`Nome da rotina ${n + 1}`} value={it.nome} onChange={e => setItem(it.chave, 'nome', e.target.value)} />
                {/* incidência (só em bloco mensal): trimestral vence no mês seguinte ao fim do
                    trimestre (jan, abr, jul, out); anual, no mês escolhido */}
                {rec === 'mensal' && (
                  <div className={css.incidencia}>
                    <select className={css.input} value={it.incidencia || 'mensal'} title="Incidência: em que meses a rotina aparece nos vencimentos"
                      onChange={e => setItem(it.chave, 'incidencia', e.target.value)}>
                      <option value="mensal">Mensal</option>
                      <option value="trimestral">Trimestral</option>
                      <option value="anual">Anual</option>
                    </select>
                    {it.incidencia === 'anual' && (
                      <select className={`${css.input} ${!it.mes_vencimento ? css.invalido : ''}`} value={it.mes_vencimento} title="Mês em que vence"
                        onChange={e => setItem(it.chave, 'mes_vencimento', e.target.value)}>
                        <option value="">vence em…</option>
                        {MESES_NOME.map((mn, i) => <option key={mn} value={i + 1}>{mn}</option>)}
                      </select>
                    )}
                  </div>
                )}
                {unica ? (
                  <input className={`${css.input} ${foraDoPeriodo(it) ? css.invalido : ''}`} type="date"
                    value={it.data} min={f.inicio || undefined} max={f.fim || undefined}
                    disabled={!periodoOk} title={periodoOk ? 'Data própria da rotina (opcional) -- sem ela, o prazo é o fim do período' : 'Informe o período primeiro'}
                    onChange={e => setItem(it.chave, 'data', e.target.value)} />
                ) : (
                  <select className={`${css.input} ${foraDoPeriodo(it) ? css.invalido : ''}`} value={it.dia}
                    disabled={!periodoOk} title={periodoOk ? 'Dia próprio da rotina (opcional) -- sem ele, o prazo é o fim do período' : 'Informe o período primeiro'}
                    onChange={e => setItem(it.chave, 'dia', e.target.value)}>
                    <option value="">sem dia</option>
                    {opcoesDia.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                  </select>
                )}
                <button type="button" className={`${css.btnLinha} ${it.setores?.length ? css.btnLinhaCom : ''}`}
                  title={`Setores: ${textoSetores(it.setores)}`}
                  onClick={() => setSetoresDe({ titulo: it.nome || `Rotina ${n + 1}`, chaves: [it.chave] })}>
                  {it.setores?.length ? textoSetores(it.setores) : 'Setores'}
                </button>
                <button type="button" className={css.btnIcone} disabled={itens.length === 1} title="Tirar"
                  onClick={() => setItens(xs => xs.filter(x => x.chave !== it.chave))}><FiX size={14} /></button>
              </div>
            ))}
            {/* etapa nova herda os setores que todas as outras já têm em comum */}
            <button type="button" className={css.btnSecundario}
              onClick={() => setItens(xs => [...xs, novaRotina(SETORES_ROTINA.map(st => st.v).filter(v => xs.length && xs.every(x => (x.setores || []).includes(v))))])}>
              <FiPlus size={13} /> Adicionar rotina
            </button>
          </div>

          {rec === 'mensal' && (
            <p className={css.dica}>Incidência: <strong>trimestral</strong> aparece só no mês seguinte ao fechamento do trimestre (janeiro, abril, julho e outubro); <strong>anual</strong>, só no mês de vencimento escolhido.</p>
          )}
          <p className={css.dica}>Os clientes desta rotina vêm dos processos (aba Processos).</p>
          {erro && <p className={css.erro}>{erro}</p>}
        </div>
        <div className={css.drawerRodape}>
          {editando && <button type="button" className={css.btnPerigo} onClick={excluir}><FiTrash2 size={13} /> Excluir</button>}
          <span style={{ flex: 1 }} />
          <button type="button" className={css.btnSecundario} onClick={onFechar}>Cancelar</button>
          <button type="button" className={css.btnPrimario} onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>
      {setoresDe && (
        <ModalSetores titulo={setoresDe.titulo} estadoDe={(v) => estadoSetor(setoresDe.chaves, v)}
          onAlternar={(v, sim) => marcarSetor(setoresDe.chaves, v, sim)} onFechar={() => setSetoresDe(null)} />
      )}
    </div>
  );
}

/* ════════════ Pacote: rotinas + clientes ════════════ */
/* Uma lista só: blocos (título) com as etapas embaixo. Cada linha tem:
     - a caixa de incluir no pacote;
     - "Clientes (N)": no título vincula em TODAS as etapas do bloco, na
       etapa só nela (pra individualizar, mexe na etapa);
     - "Repetir de…": copia os clientes de outra rotina pra essa linha
       (soma, nunca desmarca) -- várias rotinas têm os mesmos clientes.
   Vincular cliente numa etapa já inclui a etapa no pacote. */

/* lista de clientes pra marcar, de uma linha (título ou etapa) */
function ModalClientesLinha({ titulo, clientes, estadoDe, onAlternar, onAlternarTodos, onFechar }) {
  const [busca, setBusca] = useState('');
  useEsc(onFechar);
  const q = normalizar(busca.trim());
  const vis = clientes.filter(c => !q || normalizar(`${c.codigo} ${c.nome}`).includes(q));
  const marcados = vis.filter(c => estadoDe(c.id) === 'todos').length;
  const parcial = vis.some(c => estadoDe(c.id) !== 'nenhum') && marcados < vis.length;
  return (
    <div className={css.fundo} style={{ zIndex: 95, justifyContent: 'center', alignItems: 'center' }}>
      <div className={css.modalClientes}>
        <div className={css.drawerTopo}>
          <div><h3>Clientes</h3><p className={css.dica}>{titulo}</p></div>
          <button type="button" className={css.btnIcone} onClick={onFechar}><FiX size={16} /></button>
        </div>
        <div className={css.drawerCorpo}>
          <input className={css.input} placeholder="Filtrar por código ou nome..." value={busca} onChange={e => setBusca(e.target.value)} autoFocus />
          <div className={css.listaMarcar}>
            <label className={`${css.itemMarcar} ${css.itemTodos}`}>
              <input type="checkbox" checked={vis.length > 0 && marcados === vis.length}
                ref={el => { if (el) el.indeterminate = parcial; }}
                onChange={() => onAlternarTodos(vis.map(c => c.id), !(vis.length > 0 && marcados === vis.length))} />
              {q ? 'Marcar todos os filtrados' : 'Marcar todos os clientes'}
            </label>
            {vis.map(c => {
              const e = estadoDe(c.id);
              return (
                <label key={c.id} className={css.itemMarcar}>
                  <input type="checkbox" checked={e === 'todos'} ref={el => { if (el) el.indeterminate = e === 'algum'; }}
                    onChange={() => onAlternar(c.id, e !== 'todos')} />
                  <strong>{c.codigo}</strong> <span>{c.nome}</span>
                </label>
              );
            })}
          </div>
        </div>
        <div className={css.drawerRodape}>
          <span style={{ flex: 1 }} />
          <button type="button" className={css.btnPrimario} onClick={onFechar}>Pronto</button>
        </div>
      </div>
    </div>
  );
}

/* escolher a rotina de onde repetir os clientes */
function ModalRepetir({ titulo, opcoes, onRepetir, onFechar }) {
  const [origem, setOrigem] = useState('');
  useEsc(onFechar);
  return (
    <div className={css.fundo} style={{ zIndex: 95, justifyContent: 'center', alignItems: 'center' }}>
      <div className={css.modalClientes} style={{ maxWidth: 520, height: 'auto' }}>
        <div className={css.drawerTopo}>
          <div><h3>Repetir clientes de outra rotina</h3><p className={css.dica}>para: {titulo}</p></div>
          <button type="button" className={css.btnIcone} onClick={onFechar}><FiX size={16} /></button>
        </div>
        <div className={css.drawerCorpo}>
          <select className={css.input} value={origem} onChange={e => setOrigem(e.target.value)} autoFocus>
            <option value="">Escolha a rotina...</option>
            {opcoes.map(o => <option key={o.id} value={o.id}>{o.rotulo} ({o.qtd} clientes)</option>)}
          </select>
          <p className={css.dica}>Os clientes dessa rotina são somados aos que já estão marcados aqui -- ninguém é desmarcado.</p>
        </div>
        <div className={css.drawerRodape}>
          <span style={{ flex: 1 }} />
          <button type="button" className={css.btnSecundario} onClick={onFechar}>Cancelar</button>
          <button type="button" className={css.btnPrimario} disabled={!origem} onClick={() => onRepetir(origem)}>Repetir</button>
        </div>
      </div>
    </div>
  );
}

export function DrawerPacote({ registro, blocos, clientes, onFechar, onSalvo }) {
  const editando = !!registro?.id;
  const [nome, setNome] = useState(registro?.nome || '');
  const [descricao, setDescricao] = useState(registro?.descricao || '');
  const [ativo, setAtivo] = useState(registro?.ativo ?? true);
  /* setor do processo -- o lead exige processos de Folha, Fiscal e Contábil */
  const [setor, setSetor] = useState(registro?.setor || '');
  const [verTodas, setVerTodas] = useState(false);
  const [selItens, setSelItens] = useState(() => new Set(registro?.item_ids || []));
  /* vínculo "itemId|clienteId" */
  const [vinc, setVinc] = useState(() => new Set((registro?.vinculos || []).map(v => `${v.item_id}|${v.cliente_id}`)));
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [aviso, setAviso] = useState('');
  const [escolhendo, setEscolhendo] = useState(null); // { titulo, itemIds } -- modal de clientes
  const [repetindo, setRepetindo] = useState(null);   // { titulo, itemIds } -- modal de repetir
  useEsc(onFechar);

  const ativos = useMemo(() => clientes.filter(c => c.status !== 'inativo'), [clientes]);
  const idsAtivos = useMemo(() => new Set(ativos.map(c => c.id)), [ativos]);
  const chave = (itemId, cid) => `${itemId}|${cid}`;
  const todasRotinas = blocos.flatMap(b => b.itens.map(i => ({ ...i, bloco: b })));
  const rotuloRotina = (it) => [it.bloco.local, it.bloco.titulo, it.nome].filter(Boolean).join(' · ');

  /* linha = conjunto de etapas (título = todas do bloco; etapa = ela só) */
  const clientesDaLinha = (itemIds) => new Set([...vinc].map(k => k.split('|')).filter(([i]) => itemIds.includes(i)).map(([, c]) => c));
  function estadoCliente(itemIds, cid) {
    const n = itemIds.filter(i => vinc.has(chave(i, cid))).length;
    return n === 0 ? 'nenhum' : n === itemIds.length ? 'todos' : 'algum';
  }
  function marcar(itemIds, cids, sim) {
    const n = new Set(vinc);
    itemIds.forEach(i => cids.forEach(cid => (sim ? n.add(chave(i, cid)) : n.delete(chave(i, cid)))));
    setVinc(n);
    /* vincular cliente já inclui a etapa no pacote */
    if (sim) setSelItens(s => new Set([...s, ...itemIds]));
  }
  /* clientes de uma rotina: os de qualquer pacote ativo + os marcados aqui agora */
  function clientesDaRotina(itemId) {
    const it = todasRotinas.find(x => x.id === itemId);
    const ids = new Set(it?.cliente_ids || []);
    [...vinc].forEach(k => { const [i, cid] = k.split('|'); if (i === itemId) ids.add(cid); });
    return [...ids].filter(cid => idsAtivos.has(cid));
  }
  function repetir(alvo, origemId) {
    const cids = clientesDaRotina(origemId);
    const antes = vinc.size;
    const n = new Set(vinc);
    alvo.itemIds.forEach(i => cids.forEach(cid => n.add(chave(i, cid))));
    setVinc(n);
    setSelItens(s => new Set([...s, ...alvo.itemIds]));
    setAviso(`${alvo.titulo}: ${n.size - antes} vínculo(s) novo(s) a partir de ${cids.length} cliente(s).`);
    setRepetindo(null);
  }

  function alternarItem(id) {
    const n = new Set(selItens);
    if (n.has(id)) n.delete(id); else n.add(id);
    setSelItens(n);
  }
  function alternarBloco(b) {
    const todos = b.itens.every(i => selItens.has(i.id));
    const n = new Set(selItens);
    b.itens.forEach(i => (todos ? n.delete(i.id) : n.add(i.id)));
    setSelItens(n);
  }

  const q = normalizar(busca.trim());
  /* com setor escolhido, só as etapas daquele setor (as já marcadas no
     processo continuam aparecendo); "Mostrar todas" desliga o filtro */
  const etapaNoSetor = (it) => !setor || verTodas || selItens.has(it.id) || (it.setores || []).includes(setor);
  const blocosVis = blocos
    .map(b => ({ ...b, itens: b.itens.filter(etapaNoSetor) }))
    .filter(b => b.itens.length)
    .filter(b => !q || normalizar(`${b.local || ''} ${b.titulo || ''} ${b.itens.map(i => i.nome).join(' ')} ${textoRecorrencia(b)}`).includes(q));
  const vinculosValidos = [...vinc].map(k => k.split('|')).filter(([itemId]) => selItens.has(itemId));
  const qtdClientes = new Set(vinculosValidos.map(([, cid]) => cid)).size;

  async function salvar() {
    setErro('');
    if (!nome.trim()) return setErro('Informe o nome do processo.');
    setSalvando(true);
    try {
      const dados = {
        nome, descricao, ativo, setor: setor || null, itemIds: [...selItens],
        vinculos: vinculosValidos.map(([itemId, clienteId]) => ({ itemId, clienteId })),
      };
      if (editando) await atualizarPacoteRotina(registro.id, dados); else await criarPacoteRotina(dados);
      onSalvo();
    } catch (e) { setErro(e.message); setSalvando(false); }
  }
  async function excluir() {
    if (!window.confirm(`Excluir o processo "${registro.nome}"? Os clientes deixam de ter as rotinas dele.`)) return;
    try { await excluirPacoteRotina(registro.id); onSalvo(); } catch (e) { setErro(e.message); }
  }

  /* botões da linha: clientes + repetir */
  const BotoesLinha = ({ titulo, itemIds }) => {
    const qtd = clientesDaLinha(itemIds).size;
    const opcoes = todasRotinas.filter(r => !(itemIds.length === 1 && r.id === itemIds[0]))
      .map(r => ({ id: r.id, rotulo: rotuloRotina(r), qtd: clientesDaRotina(r.id).length }))
      .filter(o => o.qtd > 0);
    return (
      <span className={css.botoesLinha}>
        <button type="button" className={`${css.btnLinha} ${qtd ? css.btnLinhaCom : ''}`}
          onClick={(e) => { e.preventDefault(); setEscolhendo({ titulo, itemIds }); }}>
          <FiUsers size={11} /> Clientes ({qtd})
        </button>
        <button type="button" className={css.btnLinha} disabled={!opcoes.length}
          title={opcoes.length ? 'Vincular os mesmos clientes de outra rotina' : 'Nenhuma outra rotina tem clientes ainda'}
          onClick={(e) => { e.preventDefault(); setRepetindo({ titulo, itemIds, opcoes }); }}>
          <FiRepeat size={11} /> Repetir de…
        </button>
      </span>
    );
  };

  return (
    <div className={css.fundo}>
      <div className={`${css.drawer} ${css.drawerLargo}`}>
        <div className={css.drawerTopo}>
          <h3>{editando ? 'Editar processo' : 'Novo processo'}</h3>
          <button type="button" className={css.btnIcone} onClick={onFechar}><FiX size={16} /></button>
        </div>
        <div className={css.drawerCorpo}>
          <div className={css.linha2} style={{ gridTemplateColumns: '2fr 2fr 1fr' }}>
            <label className={css.campo}><span>Nome do processo *</span>
              <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Folha - Adiantamento, Simples Nacional..." autoFocus />
            </label>
            <label className={css.campo}><span>Descrição</span>
              <input value={descricao} onChange={e => setDescricao(e.target.value)} />
            </label>
            <label className={css.campo}><span>Setor</span>
              <select value={setor} onChange={e => setSetor(e.target.value)}>
                <option value="">Sem setor</option>
                {SETORES_ROTINA.map(x => <option key={x.v} value={x.v}>{x.l}</option>)}
              </select>
            </label>
          </div>
          <p className={css.dica}>{selItens.size} etapa(s) no processo · {qtdClientes} cliente(s). No título, "Clientes" vincula em todas as etapas do bloco; na etapa, só nela.</p>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <input className={css.input} style={{ flex: 1 }} placeholder="Filtrar rotinas..." value={busca} onChange={e => setBusca(e.target.value)} />
            {setor && (
              <label className={css.check} style={{ whiteSpace: 'nowrap', margin: 0 }} title="Por padrão aparecem só as etapas do setor do processo">
                <input type="checkbox" checked={verTodas} onChange={e => setVerTodas(e.target.checked)} /> Mostrar todas as rotinas
              </label>
            )}
          </div>
          {aviso && <p className={css.dica} style={{ color: '#166534' }}>{aviso}</p>}

          <div className={css.listaMarcar}>
            {blocosVis.length ? blocosVis.map(b => {
              const todos = b.itens.every(i => selItens.has(i.id));
              const algum = b.itens.some(i => selItens.has(i.id));
              const tituloBloco = [b.local, b.titulo].filter(Boolean).join(' · ') || 'Sem local';
              return (
                <div key={b.id}>
                  <div className={`${css.itemMarcar} ${css.itemTodos}`}>
                    <input type="checkbox" checked={todos} ref={el => { if (el) el.indeterminate = algum && !todos; }}
                      onChange={() => alternarBloco(b)} />
                    <strong>{tituloBloco}</strong> <span>{textoRecorrencia(b)}</span>
                    <BotoesLinha titulo={tituloBloco} itemIds={b.itens.map(i => i.id)} />
                  </div>
                  {b.itens.map(it => (
                    <div key={it.id} className={`${css.itemMarcar} ${css.itemFilho}`}>
                      <input type="checkbox" checked={selItens.has(it.id)} onChange={() => alternarItem(it.id)} />
                      <strong>{it.nome}</strong> <span>{textoDiaRotina(b, it)}{it.incidencia === 'trimestral' ? ' · trimestral' : it.incidencia === 'anual' ? ` · anual (vence em ${MESES_NOME[(it.mes_vencimento || 1) - 1]})` : ''}</span>
                      <BotoesLinha titulo={`${tituloBloco} · ${it.nome}`} itemIds={[it.id]} />
                    </div>
                  ))}
                </div>
              );
            }) : <p className={css.dica} style={{ padding: 10 }}>{blocos.length
              ? (setor && !verTodas ? `Nenhuma etapa com o setor ${rotuloSetor(setor)}. Defina o setor nas etapas (aba Rotinas) ou marque "Mostrar todas as rotinas".` : 'Nenhuma rotina encontrada.')
              : 'Nenhuma rotina cadastrada ainda (aba Rotinas).'}</p>}
          </div>
          <label className={css.check}><input type="checkbox" checked={ativo} onChange={e => setAtivo(e.target.checked)} /> Processo ativo</label>
          {erro && <p className={css.erro}>{erro}</p>}
        </div>
        <div className={css.drawerRodape}>
          {editando && <button type="button" className={css.btnPerigo} onClick={excluir}><FiTrash2 size={13} /> Excluir</button>}
          <span style={{ flex: 1 }} />
          <button type="button" className={css.btnSecundario} onClick={onFechar}>Cancelar</button>
          <button type="button" className={css.btnPrimario} onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>

      {escolhendo && (
        <ModalClientesLinha titulo={escolhendo.titulo} clientes={ativos}
          estadoDe={(cid) => estadoCliente(escolhendo.itemIds, cid)}
          onAlternar={(cid, sim) => marcar(escolhendo.itemIds, [cid], sim)}
          onAlternarTodos={(cids, sim) => marcar(escolhendo.itemIds, cids, sim)}
          onFechar={() => setEscolhendo(null)} />
      )}
      {repetindo && (
        <ModalRepetir titulo={repetindo.titulo} opcoes={repetindo.opcoes}
          onRepetir={(origem) => repetir(repetindo, origem)} onFechar={() => setRepetindo(null)} />
      )}
    </div>
  );
}

function AbaPacotes({ blocos, clientes }) {
  const [pacotes, setPacotes] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [editando, setEditando] = useState(null);
  const carregar = useCallback(() => {
    setCarregando(true);
    return listarPacotesRotina().then(r => setPacotes(r.items || [])).catch(e => setErro(e.message)).finally(() => setCarregando(false));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  const itemPorId = new Map(blocos.flatMap(b => b.itens.map(i => [i.id, { ...i, bloco: b }])));

  return (
    <>
      <div className={css.barraAba}>
        <p className={css.dica}>Processo junta as etapas de ponta a ponta (ex.: Pró-labore: cálculo, eSocial, guia, declaração). Dentro dele, cada cliente é marcado nas etapas que faz. Na aba Vencimentos, filtrar pelo processo mostra tudo dele junto.</p>
        <button type="button" className={css.btnPrimario} onClick={() => setEditando({})}><FiPlus size={14} /> Novo processo</button>
      </div>
      {erro && <p className={css.erro}>{erro}</p>}
      {carregando ? <p className={css.vazio}>Carregando...</p> : pacotes.length === 0 ? (
        <p className={css.vazio}>Nenhum processo ainda. Crie um (ex.: "Pró-labore"), marque as etapas e os clientes.</p>
      ) : (
        <div className={css.gradePacotes}>
          {pacotes.map(p => (
            <button key={p.id} type="button" className={`${css.pacote} ${!p.ativo ? css.inativo : ''}`} onClick={() => setEditando(p)}>
              <div className={css.pacoteTopo}><FiPackage size={15} /><strong>{p.nome}</strong>{!p.ativo && <em className={css.seloInativo}>inativo</em>}</div>
              <div className={css.dica} style={{ fontWeight: 700, color: p.setor ? '#2563eb' : '#b45309' }}>{p.setor ? rotuloSetor(p.setor) : 'Sem setor definido'}</div>
              {p.descricao && <div className={css.dica}>{p.descricao}</div>}
              <div className={css.rotinas} style={{ margin: '8px 0' }}>
                {p.item_ids.length
                  ? p.item_ids.map(id => itemPorId.get(id)).filter(Boolean).map(it => {
                    const n = p.vinculos.filter(v => v.item_id === it.id).length;
                    return <span key={it.id} className={css.rotinaChip}><strong>{it.nome}</strong>{it.bloco.local ? ` · ${it.bloco.local}` : ''} · {n} cli.</span>;
                  })
                  : <span className={css.semLocal}>sem rotinas</span>}
              </div>
              <div className={css.pacoteRodape}><FiUsers size={12} /> {new Set(p.vinculos.map(v => v.cliente_id)).size} clientes</div>
            </button>
          ))}
        </div>
      )}
      {editando && (
        <DrawerPacote registro={editando} blocos={blocos} clientes={clientes}
          onFechar={() => setEditando(null)} onSalvo={() => { setEditando(null); carregar(); }} />
      )}
    </>
  );
}

/* ════════════ Tela ════════════ */
export default function CadastroRotinas() {
  const [blocos, setBlocos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [busca, setBusca] = useState('');
  const [recFiltro, setRecFiltro] = useState('');
  const [editando, setEditando] = useState(null);
  const [aba, setAba] = useState('rotinas');

  const carregar = useCallback(() => {
    setCarregando(true);
    return listarBlocosRotina().then(r => setBlocos(r.items || []))
      .catch(e => setErro(e.message)).finally(() => setCarregando(false));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => { listarClientes().then(setClientes).catch(() => {}); }, []);

  const locais = useMemo(() => [...new Set(blocos.map(b => b.local).filter(Boolean))].sort(), [blocos]);
  const q = normalizar(busca.trim());
  const visiveis = blocos.filter(b => (!recFiltro || b.recorrencia === recFiltro)
    && (!q || normalizar(`${b.local || ''} ${b.titulo || ''} ${b.itens.map(i => i.nome).join(' ')}`).includes(q)));

  return (
    <div className={css.page}>
      <div className={css.header}>
        <div className={css.headerIcone}><FiLayers size={20} /></div>
        <h1 className={css.titulo}>Rotinas</h1>
        {aba === 'rotinas' && (
          <>
            <input className={css.busca} placeholder="Buscar rotina ou local..." value={busca} onChange={e => setBusca(e.target.value)} />
            <select className={css.busca} style={{ width: 190 }} value={recFiltro} onChange={e => setRecFiltro(e.target.value)}>
              <option value="">Todas as recorrências</option>
              {RECORRENCIAS.map(r => <option key={r.v} value={r.v}>{r.l}</option>)}
            </select>
            <button type="button" className={css.btnPrimario} onClick={() => setEditando({})}><FiPlus size={14} /> Nova rotina</button>
          </>
        )}
      </div>

      <div className={css.tabBar}>
        <button type="button" className={`${css.tab} ${aba === 'rotinas' ? css.tabAtiva : ''}`} onClick={() => setAba('rotinas')}>Rotinas</button>
        <button type="button" className={`${css.tab} ${aba === 'pacotes' ? css.tabAtiva : ''}`} onClick={() => setAba('pacotes')}>Processos</button>
      </div>

      {erro && <p className={css.erro}>{erro}</p>}

      {aba === 'pacotes' ? (
        <div className={css.conteudo}><AbaPacotes blocos={blocos} clientes={clientes} /></div>
      ) : (
      <div className={css.conteudo}>
        <table className={css.tabela}>
          <thead>
            <tr>
              <th style={{ width: 300 }}>Recorrência e período</th>
              <th style={{ width: 200 }}>Local · título</th>
              <th>Rotinas</th>
              <th style={{ width: 200 }}>Processos</th>
              <th style={{ width: 80 }}>Clientes</th>
            </tr>
          </thead>
          <tbody>
            {carregando ? (
              <tr><td colSpan={5} className={css.vazio}>Carregando...</td></tr>
            ) : visiveis.length === 0 ? (
              <tr><td colSpan={5} className={css.vazio}>Nenhuma rotina. Clique em "Nova rotina".</td></tr>
            ) : visiveis.map(b => (
              <tr key={b.id} onClick={() => setEditando(b)} className={css.linhaClicavel}>
                <td className={css.periodo}>{textoRecorrencia(b)}</td>
                <td>{[b.local, b.titulo].filter(Boolean).join(' · ') || <span className={css.semLocal}>—</span>}</td>
                <td>
                  <div className={css.rotinas}>
                    {b.itens.map(i => (
                      <span key={i.id} className={css.rotinaChip} title={`Setores: ${i.setores?.length ? i.setores.map(rotuloSetor).join(', ') : 'todos'}`}>
                        <strong>{i.nome}</strong> {textoDiaRotina(b, i)}
                        {i.setores?.length > 0 && <em className={css.chipSetor}>{i.setores.map(rotuloSetor).join(' · ')}</em>}
                      </span>
                    ))}
                  </div>
                </td>
                <td>
                  <div className={css.rotinas}>
                    {b.pacotes.length ? b.pacotes.map(n => <span key={n} className={css.pacoteChip}>{n}</span>) : <span className={css.semLocal}>nenhum</span>}
                  </div>
                </td>
                <td className={css.qtd}>{b.cliente_ids.length}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      )}

      {editando && (
        <DrawerBloco registro={editando} locais={locais}
          onFechar={() => setEditando(null)} onSalvo={() => { setEditando(null); carregar(); }} />
      )}
    </div>
  );
}
